import styled from '@emotion/styled';
import { sectionStyles } from '../css/styles';
import theme from '../theme';
import { ReactComponent as PlayCircleLine } from '@assets/play-circle-line.svg';
import { ReactComponent as GrandOpen } from '@assets/grand_open.svg';
import { ReactComponent as GetItOn } from '@assets/getItOn.svg';

import { LangContext } from '../context/LangContext';
import { DeviceContext } from '../context/DeviceContext';
import { forwardRef, useContext, useRef } from 'react';

import { FadeInSection } from '../hooks/FadeInSection';
import { Link } from 'react-router-dom';

//export default function Section1(props) {
const Section1 = forwardRef((props, ref) => {

    const { selectLanguage } = useContext(LangContext);
    const { isMobile, toolbarHeight } = useContext(DeviceContext);
    const videoRef = useRef(null);

    //alert(toolbarHeight);

    /*
    useEffect(() => {
        setTimeout(()=>{        
            const video = videoRef.current;
            if (video) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => {                
                    console.log('성공')              
                }).catch(error => {
                    console.log('실패')              
                    console.error('Video playback failed:', error);
                });
            } 
            }
            return () => {          
            if (video) {
                //console.log('리턴')
                video.pause();
                video.currentTime = 0;
            }
            };
        }, 1000)
    }, []);
    */

    const Section1 = styled.section`    
        ${sectionStyles}
        height:1200px;
        //background-image: url('/images/bg/main_bg_2560.png');
        background-size: cover;
        text-align:center;
        margin:auto;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('/images/bg/scar1.png');
            background-size: cover;
            z-index:2;
            //background-position: center;
            //opacity: 0.5; 
        }

        // ${theme.breakpoints.xl} {
        //     background-size: cover; 
        //     background-position: center center;
        //     background-repeat: no-repeat;
        // }

        ${theme.breakpoints.xl_1920} {                        
            height:900px;
            background-size: cover; 
            background-position: center center;
            background-repeat: no-repeat;

            &::before {
                background-image: url('/images/bg/scar1_1920.png');
            }
        }

        ${theme.breakpoints.xl} {            
            height: calc(100% - ${({ toolbarHeight }) => toolbarHeight}px);
            min-height: 100%;
            min-heght: -webkit-fill-available;

            &::before {                
                background-image: url('');                
            }            
        }        
    `;

    // 검은색 배경 및 dotted
    const Section1Inner = styled.div`                
        ${sectionStyles}        
    `;

    const Section1DottedBg = styled.div`
        width:100%;
        height:100%; 
        background:rgba(0, 0, 0, .3);
        background-image: url('/images/bg/top_bg_2560.png');
        background-size: cover;
        position:absolute;
        top:0;
        left:0;
        z-index:2;
    `;

    // Section1Inner 안쪽에 Flex 레이아웃용 컨테이너
    const ContentFlexContainer = styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 80px 160px;
        position: relative;
        z-index: 2;

        ${theme.breakpoints.xl} {
            flex-direction: column;
            padding: 40px 20px;
            gap: 32px;
        }
    `;

    const MainContent = styled.div`
        width: 100%;
        position: relative;
        z-index: 3;
        

        ${theme.breakpoints.xl} {
            width: 100%;
            transform: none;
        }
            
    `;

    // 오른쪽 이미지 wrapper
    const RightImageWrapper = styled.div`
        width: 50%;
        position: relative;
        z-index: 2;
        transform: translate(-100px, -70px); // 💡 왼쪽으로 더 밀어 살짝 겹치게

        display: flex;
        justify-content: center;

        img {
            max-width: 100%;
            height: auto;
        }

        ${theme.breakpoints.xl} {
            width: 100%;
            transform: none;
        }
    `;

    const MainContentImg = styled.div`
        margin-bottom: 34px;        

        img{
            height:290px;
        }

        ${theme.breakpoints.xl_1920} {
            img{
                height:200px;
            }
        }

        ${theme.breakpoints.xl} {
            margin-bottom: 16px;

            img{
                height:120px;
            }
        }
    `;

    const MainContentPlayButton = styled.div`
    
    `;

    const MainContentTitle1 = styled.div`        
        color:#dbd8d7;        
        font-size:2.125rem;
        opacity:0.8;
        margin-bottom:14px;

        ${theme.breakpoints.xl_1920} {
            font-size:30px;
        }

        ${theme.breakpoints.xl} {
            font-size:17px;
            margin: 64px 0 10px 0;
            letter-spacing: -.5px;
        }
    `;

    const SoonPreOrderText = styled.div`        
        color:#dbd8d7;       
        opacity:0.8;

        ${theme.breakpoints.xl_1920} {
            font-size:2.5rem;
        }   

        ${theme.breakpoints.xl} {
            font-size:1.5rem;
        }
    `;

    const MainContentTitle2 = styled.div`
        margin-top: 0px;        
        color: #FFF;
        text-align: center;        
        text-shadow: 0px 0px 95.52px rgba(255, 255, 255, 0.70);        
        font-size: 110px;                

        ${theme.breakpoints.xl_1920} {
            font-size:80px;
        }

        ${theme.breakpoints.xl} {
            text-shadow: 0px 0px 43.409px #FFF;
            font-size:42px;
            margin-bottom:16px;
        }
    `;

    const MainContentTitle3 = styled.div`  
        height: 130px;
        transform: translateX(-30px); // 👈 왼쪽으로 이동
        svg{
            height:100%;
            -webkit-filter: drop-shadow( 0px 0px 40px rgba(255, 255, 255, 1));
            filter: drop-shadow( 0px 0px 40px rgba(255, 255, 255, 1));
            
            //-webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
            //filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
        }
        
        ${theme.breakpoints.xl} {
            height: 36px;
            margin-bottom:24px;
            transform: translateX(0); // 모바일에서는 원래 위치로 복원
            svg{
                height:100%;
            }         
        }
    `;
    const MainContentPreRegiButton = styled.div`        
        // display: flex;
        // width: 520px;
        // height: 100px;        
        // margin: 40px auto 0 auto;
        // justify-content: center;
        // align-items: center;        

        // border-radius: 6px;
        // border: 2px solid #FFF;
        // background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
        // box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);
        // cursor:pointer;

        // color: #FFF;                
        // font-size: 40px;

        // ${theme.breakpoints.xl_1920} {
        //     width: 460px;
        //     height: 80px;  
        //     font-size:32px;
        // }

        img{
            margin: 40px auto 0 auto;
            width:330px;

            // &:hover{
            //     display:inline-block;
            //     scale: 1.05;
            // }
            
            transition:all 0.2s ease;

            &:active{                
                display:inline-block;
                scale: 1.1;
            }
        }

        ${theme.breakpoints.xl} {
            img{
                margin: 0 auto;
                width:260px;
            }
        }
    `;
    const MainContentPoweredBy = styled.div`
        margin:24px 0 26px 0;
        color:#dbd8d7;
        font-size:1.625rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap:16px;

        ${theme.breakpoints.xl_1920} {            
            font-size:22px;
        }

        ${theme.breakpoints.xl} {
            margin:10px 0;
            font-size:12px;
            gap:8px;
        }
    `;

    const PoweredByEmotion = styled.svg`
        
        height:30px;

        ${theme.breakpoints.xl_1920} {            
            height:24px;
        }

        ${theme.breakpoints.xl} {            
            height:16px;
        }
    `;

    const MainButtonBox = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:10px;
        cursor:pointer;
        //position:absolute;
        //z-index:99;

        ${theme.breakpoints.xl} {            
            gap:8px;
        }
    `;
    const MainDownLoadButton = styled.div`
        img{
            height:60px;
        }

        ${theme.breakpoints.xl_1920} {            
            img{
                height:53px;
            }
        }
        ${theme.breakpoints.xl} {
            img{
                height:32px;
            }
        }
    `;

    const ScarBackground = styled.div`
        width:100%;     
        height:100%;   
        background-image: url('/images/bg/scar1.png');
        background-size:contain;
        background-repeat:no-repeat;
        color:white;

        position:absolute;
        bottom:-20px;
        z-index:1;
    `;

    const VideoContainer = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        opacity: 1;
    `;

    // 비디오 태그 스타일 정의
    const Video = styled.video`
        height: 100%;
        width: 100%;
        object-fit: cover; 
    `;
    const PreRegiButtonBox = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 0px;

        a {
            display: inline-block;
        }

        ${theme.breakpoints.xl} {
            flex-direction: column;
            gap: 2px;
        }
    `;

    return (
        <Section1 ref={ref} toolbarHeight={toolbarHeight} >
            <Section1DottedBg></Section1DottedBg>
            <VideoContainer>
                <Video
                    ref={videoRef}
                    autoPlay
                    loop
                    webkit-playsinline="true"
                    muted
                    playsInline
                    preload="auto"
                >
                    {/* playsinline autoplay */}
                    <source src="/images/bg/pv_saga.mp4" type="video/mp4" />
                    {/* <source src="/images/bg/test.mp4" type="video/mp4" /> */}
                    {/* <source src={`/images/bg/MTDZ SAGA_PV_${selectLanguage === '한국어' ? 'KR' : 'EN'}.mp4`} type="video/mp4" /> */}
                    {/* <source src="img/video.webm" type="video/webm" /> */}
                    Your browser is not supported!
                </Video>
            </VideoContainer>

            <Section1Inner>
                <ContentFlexContainer>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={
                            { display: 'flex', position: 'relative', width: '100%', maxWidth: '1200px', flexDirection: 'column' } 
                        }>
                            <MainContent>
                                <FadeInSection>
                                    <MainContentImg>
                                        <img src="/images/logo/SAGA_Rebranding_BI_big.png" alt="메인 이미지" style={{
                                            transform: 'translateY(50px)',
                                            zIndex: 1,
                                        }} />
                                    </MainContentImg>
                                </FadeInSection>

                                <FadeInSection>
                                    <MainContentTitle1 style={{
                                        transform: isMobile ? 'translateY(0px)' : 'translateY(20px)',
                                    }}>
                                        {selectLanguage === '한국어' ?
                                            ( <>
                                                작지만 치명적인<br />
                                                장난감 드래곤들의 대혈투
                                            </>) :
                                            ( <>
                                                Tiny But Deadly:<br />
                                                Clash of Toy Dragons
                                            </> )}
                                    </MainContentTitle1>
                                    <MainContentTitle3>
                                        <GrandOpen style={{
                                            transform: 'translateY(0px)',
                                        }} />
                                    </MainContentTitle3>
                                </FadeInSection>

                                {/* {
                                    isMobile &&
                                    <FadeInSection fade>
                                        <img
                                            src={selectLanguage === '한국어' ? "/images/pre_kr.png" : "/images/pre_en.png"}
                                            alt="reservation"
                                            style={{
                                                position: 'relative',
                                                top: '-100px',
                                                width: '60%', // 원하는 크기 조정
                                                zIndex: 1,
                                            }}
                                        />
                                    </FadeInSection>
                                } */}
                            </MainContent>

                            

                            {
                                <PreRegiButtonBox style={{
                                    position: 'relative',
                                    top: '-10px',
                                    zIndex: 999,
                                }}>
                                    <FadeInSection late>
                                        <Link to="https://apps.apple.com/us/app/meta-toy-dragonz/id6748107724" target='_blank'>
                                            <MainContentPreRegiButton>
                                                <img src={`/images/logo/appStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="pre-regi_app" />
                                            </MainContentPreRegiButton>
                                        </Link>
                                    </FadeInSection>
                                    <FadeInSection late>
                                        <Link to="https://play.google.com/store/apps/details?id=com.sandboxgame.mtdsaga" target='_blank'>
                                            <MainContentPreRegiButton>
                                                <img src={`/images/logo/playStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="pre-regi_gg" />
                                            </MainContentPreRegiButton>
                                        </Link>
                                    </FadeInSection>
                                </PreRegiButtonBox>

                                // isMobile && 
                                // <FadeInSection late>
                                //     <SoonPreOrderText style={{
                                //                 transform: 'translateY(-50px)',
                                //                 zIndex: 1,
                                //             }}>
                                //             {selectLanguage === '한국어' ?
                                //                 (<>
                                //                     사전예약이 곧 시작될 예정입니다.   
                                //                 </>) :
                                //                 (<>
                                //                     Pre-orders will begin soon.
                                //                 </>)}
                                //     </SoonPreOrderText>
                                // </FadeInSection>
                            }
                        </div>
                        <Link to="https://www.marblex.io/en" target="_blank">
                            <GetItOn />
                        </Link>
                    </div>
                </ContentFlexContainer>
            </Section1Inner>
            {/* <ScarBackground>이거 왜 안나와</ScarBackground> */}
        </Section1>
    )
});

export default Section1;